<template>
  <div>
    <Loading :value="loading"></Loading>
    <!-- MODAL AJOUTER UNE ZONES -->
    <v-dialog
      v-model="dialogDetailCmd"
      scrollable
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Détail de la commande analyser par le comparateur </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-layout row class="mb-4">
            <v-flex xs12 class="mb-3">
              <v-card v-if="commandeDeriv.length != 0">
                <v-toolbar class="text-xs-center" color="cyan" dark>
                  <v-toolbar-title
                    >COMMANDE(S) SUGGEREE(S) POUR LES FOURNISSEURS AYANT TOUS
                    LES PRODUITS DE LA COMMANDE</v-toolbar-title
                  >
                </v-toolbar>
                <v-card-title class="text-xs-center">
                  <v-container>
                    <v-layout wrap class="mb-2">
                      <v-flex xs4>
                        <v-chip
                          color="orange"
                          text-color="white"
                          style="font-size:18px"
                        >
                          <v-avatar class="orange darken-4">
                            {{ nbCommandeSug }}
                          </v-avatar>
                          Fournisseur(s) proprosant des meilleurs prix pour
                          ce(s) produit(s)
                        </v-chip>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-container>
                    <v-layout
                      v-for="(fourn, indF) in commandeDeriv"
                      :key="indF"
                    >
                      <v-flex class="mb-4 pl-3 pt-3 mr-3 elevation-5" xs12>
                        <v-flex xs12 class="text-xs-right" v-if="indF == 0">
                        </v-flex>
                        <v-flex xs8 class="mb-2">
                          <v-chip
                            label
                            outline
                            color="green darken-1"
                            class="elevation-4 text-xs-left"
                            style="width:100%"
                          >
                            <span class="subheading"
                              >Fournisseur : &nbsp; &nbsp;
                            </span>
                            <span class="title text-xs-left">
                              {{ fourn.fournisseur }}</span
                            >
                          </v-chip>
                          <v-chip
                            label
                            outline
                            color="green darken-1"
                            class="elevation-4"
                            style="width:100%"
                          >
                            <span class="subheading"
                              >Total HT: &nbsp; &nbsp;
                            </span>
                            <span class="title">
                              {{
                                new Intl.NumberFormat().format(fourn.mntTotalHt)
                              }}
                              Fcfa
                            </span>
                          </v-chip>
                          <v-chip
                            label
                            outline
                            color="green darken-1"
                            class="elevation-4"
                            style="width:100%"
                          >
                            <span class="subheading"
                              >Total TTC:&nbsp; &nbsp;
                            </span>
                            <span class="title">
                              {{
                                new Intl.NumberFormat().format(fourn.mntTotal)
                              }}
                              Fcfa
                            </span>
                          </v-chip>
                        </v-flex>

                        <v-flex xs12>
                          <el-table :data="fourn.produits">
                            <el-table-column
                              prop="codeGestion"
                              label="Code analytique"
                            >
                            </el-table-column>
                            <el-table-column
                              prop="libelleProduit"
                              label="Libelle"
                            >
                            </el-table-column>
                            <el-table-column prop="unite" label="Unité">
                            </el-table-column>
                            <el-table-column prop="qteProd" label="Quantite">
                            </el-table-column>
                            <el-table-column
                              prop="prixUFormat"
                              label="Prix Unitaire (Fcfa)"
                            ></el-table-column>
                            <el-table-column
                              prop="tva"
                              label="Tva"
                            ></el-table-column>
                            <el-table-column
                              prop="mntTotalHt"
                              label="Total HT (Fcfa)"
                            >
                              <template slot-scope="scope">
                                <el-tag>
                                  {{ scope.row.mntTotalFormatHt }}</el-tag
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="mntTotal"
                              label="Total TTC (Fcfa)"
                            >
                              <template slot-scope="scope">
                                <el-tag> {{ scope.row.mntTotalFormat }}</el-tag>
                              </template>
                            </el-table-column>
                          </el-table>
                          <v-flex xs12 class="text-xs-right">
                            <v-tooltip top v-if="indF != 0">
                              <v-btn
                                v-if="true"
                                slot="activator"
                                color="orange"
                                @click="creeCommande(fourn, indF, 1)"
                                dark
                              >
                                Créer commande
                                <v-icon right>check</v-icon> </v-btn
                              >Créer une commande chez ce fournisseur
                            </v-tooltip>

                            <v-tooltip top v-if="indF == 0">
                              <v-btn
                                v-if="true"
                                slot="activator"
                                color="green"
                                @click="creeCommande(fourn, indF, 1)"
                                dark
                              >
                                Créer commande
                                <v-icon right>check</v-icon> </v-btn
                              >Créer une commande chez ce fournisseur
                            </v-tooltip>
                          </v-flex>
                        </v-flex>

                        <v-divider class="mb-3"></v-divider>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-title>
              </v-card>
              <br />

              <v-card v-if="commandeDerivDeux.length != 0">
                <v-toolbar class="text-xs-center" color="teal" dark>
                  <v-toolbar-title
                    >COMMANDE(S) SUGGEREE(S) POUR LES FOURNISSEURS AYANT
                    CERTAINS PRODUITS DE LA COMMANDE</v-toolbar-title
                  >
                </v-toolbar>
                <v-card-title class="text-xs-center">
                  <v-container>
                    <v-layout wrap class="mb-2">
                      <v-flex xs4>
                        <v-chip
                          color="orange"
                          text-color="white"
                          style="font-size:18px"
                        >
                          <v-avatar class="orange darken-4">
                            {{ nbCommandeSugDeux }}
                          </v-avatar>
                          Fournisseur(s) proprosant des meilleurs prix pour
                          ce(s) produit(s)
                        </v-chip>
                      </v-flex>
                    </v-layout>
                  </v-container>

                  <v-container>
                    <v-layout
                      v-for="(fourn, indF) in commandeDerivDeux"
                      :key="indF"
                    >
                      <v-flex class="mb-4 pl-3 pt-3 mr-3 elevation-5" xs12>
                        <v-flex xs12 class="text-xs-right" v-if="indF == 0">
                        </v-flex>
                        <v-flex xs8 class="mb-2">
                          <v-chip
                            label
                            outline
                            color="green darken-1"
                            class="elevation-4 text-xs-left"
                            style="width:100%"
                          >
                            <span class="subheading"
                              >Fournisseur :&nbsp; &nbsp;
                            </span>
                            <span class="title text-xs-left">
                              {{ fourn.fournisseur }}</span
                            >
                          </v-chip>
                          <v-chip
                            label
                            outline
                            color="green darken-1"
                            class="elevation-4"
                            style="width:100%"
                          >
                            <span class="subheading"
                              >Total HT: &nbsp; &nbsp;
                            </span>
                            <span class="title">
                              {{
                                new Intl.NumberFormat().format(fourn.mntTotalHt)
                              }}
                              Fcfa
                            </span>
                          </v-chip>
                          <v-chip
                            label
                            outline
                            color="green darken-1"
                            class="elevation-4"
                            style="width:100%"
                          >
                            <span class="subheading"
                              >Total TTC: &nbsp; &nbsp;
                            </span>
                            <span class="title">
                              {{
                                new Intl.NumberFormat().format(fourn.mntTotal)
                              }}
                              Fcfa
                            </span>
                          </v-chip>
                        </v-flex>

                        <v-flex xs12>
                          <el-table :data="fourn.produits">
                            <el-table-column
                              prop="codeGestion"
                              label="Code analytique"
                            >
                            </el-table-column>
                            <el-table-column
                              prop="libelleProduit"
                              label="Libelle"
                            >
                            </el-table-column>
                            <el-table-column prop="unite" label="Unité">
                            </el-table-column>
                            <el-table-column prop="qteProd" label="Quantite">
                            </el-table-column>
                            <el-table-column
                              prop="prixUFormat"
                              label="Prix Unitaire (Fcfa)"
                            ></el-table-column>
                            <el-table-column
                              prop="tva"
                              label="Tva"
                            ></el-table-column>
                            <el-table-column
                              prop="mntTotalHt"
                              label="Total HT (Fcfa)"
                            >
                              <template slot-scope="scope">
                                <el-tag>
                                  {{ scope.row.mntTotalFormatHt }}</el-tag
                                >
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="mntTotal"
                              label="Total TTC (Fcfa)"
                            >
                              <template slot-scope="scope">
                                <el-tag> {{ scope.row.mntTotalFormat }}</el-tag>
                              </template>
                            </el-table-column>
                          </el-table>
                          <v-flex xs12 class="text-xs-right">
                            <v-tooltip top v-if="indF != 0">
                              <v-btn
                                v-if="true"
                                slot="activator"
                                color="orange"
                                @click="creeCommande(fourn, indF, 2)"
                                dark
                              >
                                Créer commande
                                <v-icon right>check</v-icon> </v-btn
                              >Créer une commande chez ce fournisseur
                            </v-tooltip>

                            <v-tooltip top v-if="indF == 0">
                              <v-btn
                                v-if="true"
                                slot="activator"
                                color="green"
                                @click="creeCommande(fourn, indF, 2)"
                                dark
                              >
                                Créer commande
                                <v-icon right>check</v-icon> </v-btn
                              >Créer une commande chez ce fournisseur
                            </v-tooltip>
                          </v-flex>
                        </v-flex>

                        <v-divider class="mb-3"></v-divider>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-title>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-tooltip top>
        <v-btn
          class="mb-5"
          style="margin-right: 30px"
          absolute
          @click.stop="closeDialog()"
          slot="activator"
          dark
          fab
          large
          bottom
          right
        >
          <v-icon>close</v-icon>
        </v-btn>
        <span>Femer</span>
      </v-tooltip>
    </v-dialog>

    <v-dialog v-model="dialogConfirmation" max-width="400">
      <v-card>
        <v-card-title class="headline"
          >Voulez-vous valider les commandes proposées ?</v-card-title
        >

        <v-card-text>
          Après la confirmation, les commandes ne pourront plus être modifiées
          et seront soumises pour validation au DIRECTEUR GENERAL, vous serez
          informé par des notifications sms et mail.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            flat="flat"
            @click="dialogConfirmation = false"
          >
            Annuler
          </v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            :disabled="loading"
            @click="validCmdDerivees()"
          >
            Confirmer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE COMMANDE -->
    <v-dialog
      v-model="dialogComm"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Creer une nouvelle commande depuis le comparateur</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogComm = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p align="center">
            <v-chip text-color="white" label color="primary" style="width:100%">
              DETAILS ASSOCIE A LA COMMANDE
              <v-icon right>shopping_cart</v-icon>
            </v-chip>
          </p>

          <v-form v-model="valid" ref="formComm" lazy-validation id="formComm">
            <v-container fluid grid-list-md>
              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Fournisseur *</span>
                    <el-input
                      v-model="selectFourn"
                      :readonly="true"
                      placeholder="Fournisseur"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>

                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Intitulé de la commande *</span>
                    <el-input
                      name="libelle"
                      placeholder="Intitulé de la commande"
                      v-model="libelle"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Date de livraison *</span>
                    <el-date-picker
                      v-model="dateLivr"
                      name="dateLivr"
                      id="dateLivr"
                      value-format="yyyy-MM-dd"
                      value="dd-MM-yyyy"
                      type="date"
                      placeholder="Date de livraison"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Priorité commande</span>
                    <el-select
                      v-model="priorite"
                      required
                      placeholder="Priorite"
                    >
                      <el-option
                        v-for="item in priorites"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row v-if="projetLib != ''">
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Projet concerné</span>
                    <el-input
                      v-model="projetLib"
                      placeholder="Projet"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Chantier concerné</span>
                    <el-input
                      v-model="chantieretLib"
                      placeholder="Chantier"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Travaux</span>
                    <el-input
                      v-model="travauxLib"
                      placeholder="Travaux"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row v-if="projetLib == '' && entrepotLib != ''">
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Magasin concerné</span>
                    <el-input
                      v-model="entrepotLib"
                      placeholder="Entrepot"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row v-if="entrepotLib == '' && travauxLib == ''">
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Autre</span>
                    <el-input
                      value="Autre"
                      placeholder="AUTRE"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <p align="center">
                <v-chip
                  outline
                  text-color="primary"
                  label
                  color="primary"
                  style="width:100%"
                >
                  DETAILS DES LIGNES DE LA COMMANDE
                  <v-icon right>shopping_cart</v-icon>
                </v-chip>
              </p>
              <el-row>
                <div class="text item">
                  <v-layout wrap justify>
                    <v-flex md12>
                      <v-chip
                        outline
                        text-color="primary"
                        label
                        color="primary"
                        style="font-size:29px"
                      >
                        MONTANT HT :
                        {{ new Intl.NumberFormat().format(totalComHT) }} FCFA
                      </v-chip>
                    </v-flex>
                  </v-layout>
                  <v-layout row justify>
                    <v-flex md12>
                      <v-chip
                        outline
                        text-color="primary"
                        label
                        color="primary"
                        style="font-size:29px"
                      >
                        MONTANT TVA :
                        {{ new Intl.NumberFormat().format(totalComTVA) }} FCFA
                      </v-chip>
                    </v-flex>
                  </v-layout>
                  <v-layout row justify>
                    <v-flex md12>
                      <v-chip
                        outline
                        text-color="orange"
                        label
                        color="orange"
                        style="font-size:29px"
                      >
                        MONTANT TTC :
                        {{ new Intl.NumberFormat().format(totalComTTC) }} FCFA
                      </v-chip>
                    </v-flex>
                  </v-layout>
                </div>
              </el-row>

              <v-flex xs12>
                <el-table :data="listproduitFournisseur.produits">
                  <el-table-column prop="codeGestion" label="Code analytique">
                  </el-table-column>
                  <el-table-column prop="libelleProduit" label="Libelle">
                  </el-table-column>
                  <el-table-column prop="unite" label="Unité">
                  </el-table-column>
                  <el-table-column prop="qteProd" label="Quantite">
                  </el-table-column>
                  <el-table-column
                    prop="prixUFormat"
                    label="Prix Unitaire (Fcfa)"
                  ></el-table-column>
                  <el-table-column prop="tva" label="Tva"></el-table-column>
                  <el-table-column prop="mntTotal" label="Total (Fcfa)">
                    <template slot-scope="scope">
                      <el-tag> {{ scope.row.mntTotalFormat }}</el-tag>
                    </template>
                  </el-table-column>
                </el-table>
              </v-flex>
              <br />
            </v-container>
            <v-flex xs12 class="text-xs-right">
              <v-btn @click="dialogComm = false" color="orange" dark>
                Annuler
                <v-icon right>close</v-icon>
              </v-btn>
              <v-btn
                icons
                color="blue"
                @click="dialogConfirmation = true"
                :disabled="!valid"
                dark
              >
                Enregistrer
                <v-icon right>save</v-icon>
              </v-btn>
            </v-flex>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "ModalComparateurCmd",
  props: {
    showModalCompCmd: {
      type: Boolean
    },
    show: {
      type: Boolean
    },
    infOrenseigner: {
      type: Array
    },
    commandeDeriv: {
      type: Array,
      required: false
    },
    commandeDerivDeux: {
      type: Array
    },
    mntTotalCmd: {
      type: String
    },
    nbCommandeSug: {
      type: Number
    },
    nbCommandeSugDeux: {
      type: Number
    },
    typeCommande: {
      type: Number,
      default: 1 //1=>Commande avec des options commandes//2=> commande avec des optionBesoins
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),

      loading: false,
      dialogDetailCmd: false,
      dialogComm: false,
      deleteValeur: 0,
      valid: true,
      dialogConfirmation: false,
      fourSelct: [],
      listproduitFournisseur: [],
      selectFourn: "",
      dateLivr: "",
      priorite: "",
      libelle: "",
      totalComHT: 0,
      totalComTVA: 0,
      totalComTTC: 0,
      indexFour: "",

      //details de commande
      projetLib: "",
      entrepotLib: "",
      chantieretLib: "",
      travauxLib: "",
      priorites: [
        {
          value: 1,
          label: "Faible"
        },
        {
          value: 2,
          label: "Normal"
        },
        {
          value: 3,
          label: "Urgent"
        }
      ]
    };
  },

  computed: {},
  watch: {
    show: function(newValue, oldvalue) {
      this.dialogDetailCmd = newValue;
      if (newValue == true) {
        //this.nbCmdDerive = this.cmdDerbivees.length
      }
    }
  },

  methods: {
    validCmdDerivees() {
      this.loading = true;
      this.dialogConfirmation = false;
      this.showModalCompCmd = false;
      var formdata = new FormData();
      formdata.append("commandes", JSON.stringify(this.listproduitFournisseur));
      formdata.append("idUser", this.user.id);
      formdata.append("typeCommande", this.typeCommande);
      formdata.append("prioriteCommande", this.priorite);
      formdata.append("idTravaux", this.infOrenseigner[6]);
      let url = this.domaine + "comparateur/commande/new/create";
      this.$http.post(url, formdata).then(
        response => {
          this.loading = false;
          this.dialogComm = false;
          if (this.deleteValeur == 1) {
            this.commandeDeriv.splice(this.indexFour);
          } else {
            this.commandeDerivDeux.splice(this.indexFour);
          }
          this.$notify({
            title: "VALIDATION REUSSIE",
            message: "Les commandes ont été enregitrées.",
            type: "success",
            position: "top-center"
          });
          this.closeDialog();
        },
        error => {
          this.$message.error("Erreur serveur");
          this.loading = false;
          this.closeDialog();
        }
      );
    },
    creeCommande(item, index, type) {
      this.dialogComm = true;
      this.deleteValeur = type;
      this.libelle = this.infOrenseigner[0];
      this.dateLivr = this.infOrenseigner[1];
      let prioriteSelect = this.infOrenseigner[2];
      this.projetLib = this.infOrenseigner[3];
      this.travauxLib = this.infOrenseigner[4];
      this.chantieretLib = this.infOrenseigner[5];
      this.entrepotLib = this.infOrenseigner[7];
      this.selectFourn = item.fournisseur;

      // id du fournisseur selectionner pour la suppresion dans la liste des propositions
      this.indexFour = index;
      const fini = this.priorites.find(prod => {
        if (prod.value == prioriteSelect) {
          return prod.label;
        }
      });
      this.priorite = fini.label;
      this.listproduitFournisseur = item;
      let tabFounr = item.produits;
      this.totalComHT = 0;
      this.totalComTVA = 0;
      this.totalComTTC = 0;
      for (let prop in item.produits) {
        let currentC = item.produits[prop];

        this.totalComHT += currentC.prixU * currentC.qteProd;
        this.totalComTVA += Math.round(
          currentC.prixU * currentC.qteProd * (currentC.tva / 100)
        );
        let tot =
          currentC.prixU * currentC.qteProd +
          Math.round(currentC.prixU * currentC.qteProd * (currentC.tva / 100));
        this.totalComTTC += tot;
      }
    },
    closeDialog() {
      this.$emit("close");
    }
  }, //methods

  mounted() {}
};
</script>



// WEBPACK FOOTER //
// src/components/comparateur/ModalComparateurCmd.vue